import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ roles }) => {
    const {
        isLoggedIn,
        isAdminLoggedIn,
        user,
        admin,
        loading,
    } = useSelector((state) => state.auth);

    // Determine current logged-in user based on role
    const isCurrentLoggedIn = isLoggedIn || isAdminLoggedIn;
    const currentUser = isAdminLoggedIn ? admin : user;

    // While loading auth state
    if (loading) {
        return <div className="text-center py-10">Checking authentication...</div>;
    }

    // Not logged in
    if (!isCurrentLoggedIn || !currentUser) {
        return <Navigate to="/" replace />;
    }

    // Role check
    if (roles && !roles.includes(currentUser?.role)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;